module.exports = __webpack_public_path__ + "img/info-con-ov.0470907e.png";